export const REDUX_VIEW_TYPES = {
  USER_MENU_VISIBLE: 'USER_MENU_VISIBLE',
  IS_LOADING: 'IS_LOADING',
  TOAST: 'TOAST',
  BOARD_DRAG_RESULT: 'DRAG_RESULT',
  STATUS_DRAGGED: 'STATUS_DRAGGED',
  STATUS_DROPPED: 'STATUS_DROPPED',
  BOARD_GROUP: 'BOARD_GROUP',
  LIST_MODE: 'LIST_MODE',
  COLUMN_TYPE: 'COLUMN_TYPE',
  USER_MODE: 'USER_MODE',
  MULTI_SELECT_MODE: 'MULTI_SELECT_MODE',
  SHARE_MODE: 'SHARE_MODE',
  ASSIGN_TEAM_MODE: 'ASSIGN_TEAM_MODE',
  MULTI_EDIT_MODE: 'MULTI_EDIT_MODE',
  TOGGLE_FILTERS: 'TOGGLE_FILTERS',
  TOGGLE_GROUPING: 'TOGGLE_GROUPING',
  DISABLE_GROUPING: 'DISABLE_GROUPING',
  RESET_TO_DEFAULT_SORT: 'RESET_TO_DEFAULT_SORT'
}

export const setUserMenuVisible = (isVisible) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.USER_MENU_VISIBLE,
  payload: isVisible
})

export const setLoading = (isLoading) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.IS_LOADING,
  payload: isLoading
})

export const dispatchToast = (toast) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.TOAST,
  payload: toast
})

export const dispatchBoardDragResult = (dragResult) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.BOARD_DRAG_RESULT,
  payload: dragResult
})

export const dispatchBoardGroup = (group) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.BOARD_GROUP,
  payload: group
})

export const dipatchListMode = (mode) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.LIST_MODE,
  payload: mode
})

export const dipatchColumnType = (columnType) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.COLUMN_TYPE,
  payload: columnType
})

export const dipatchUserMode = (userMode) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.USER_MODE,
  payload: userMode
})

export const dispatchMultiSelectMode = (mode) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.MULTI_SELECT_MODE,
  payload: mode
})

export const dispatchMultiEditMode = (mode) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.MULTI_EDIT_MODE,
  payload: mode
})

export const dispatchAssignTeamMode = (mode) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.ASSIGN_TEAM_MODE,
  payload: mode
})

export const dispatchToggleFilters = (state) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.TOGGLE_FILTERS,
  payload: state
})

export const dispatchDisableGrouping = () => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.DISABLE_GROUPING,
  payload: false
})

export const dispatchToggleGrouping = (state) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.TOGGLE_GROUPING,
  payload: state
})

export const dispatchResetToDefaultSort = (state) => (dispatch) => dispatch({
  type: REDUX_VIEW_TYPES.RESET_TO_DEFAULT_SORT,
  payload: state
})
